import { ArticulosEcommerce } from '../interfaces/articulos-ecommerce.interface';
import { OfertasEcommerce } from '../interfaces/ofertas-ecommerce.interface';
import { TagsEcommerce } from '../interfaces/tags-eccomerce.interface';
import { PromocionesEccomerce } from './promociones-class';

/**
 * Promocion tipo N ("Promo NxM"): un solo articulo (items[0]), donde
 * item.cantidad1 = unidades que hay que llevar y item.cantidad2 = unidades
 * que efectivamente se pagan (ej. 3x2: cantidad1=3, cantidad2=2). El precio
 * unitario usado para el calculo es item.precioReal, tal como lo trae el
 * backend, no el precio en vivo del catalogo.
 */
export class NxMPromo extends PromocionesEccomerce {

  setTag(tag: TagsEcommerce) {
    throw new Error('Method not implemented.');
  }

  getTag(): TagsEcommerce[] {
    throw new Error('Method not implemented.');
  }

  getMarcaReal() {
    return '';
  }

  getCantidad() {
    return this.counter;
  }

  getCantidadMayorista() {
    return 0;
  }

  getRemplazos() {
    throw new Error('Method not implemented.');
  }

  isdeOferta(): boolean {
    return false;
  }

  setdeOferta(ofertas: OfertasEcommerce) {
    throw new Error('Method not implemented.');
  }

  getPromosActivas(): string[] {
    return [];
  }

  getDescripcionAdicional() {
    return ' ';
  }

  getCantidadMaxima() {
    return 0;
  }

  getPrecioMayorista() {
    return 0;
  }

  getPrecioOferta(): number {
    return 0;
  }

  getPrecioNormal() {
    return 0;
  }

  getPresentacion() {
    return '';
  }

  setModificacionPrecio(arg0: number) {
    throw new Error('Method not implemented.');
  }

  setPromo(k: PromocionesEccomerce) {
    throw new Error('Method not implemented.');
  }

  setRemplazo(numero: number) {
    throw new Error('Method not implemented.');
  }

  getRemplazo() {
    throw new Error('Method not implemented.');
  }

  getPrecioPartido(): number {
    throw new Error('Method not implemented.');
  }

  getOtrosPrecios(): string {
    throw new Error('Method not implemented.');
  }

  getFraccion() {
    return 0;
  }

  getImgDownload(): boolean {
    return this.descargo;
  }

  setImgDownload(valor: boolean) {
    this.descargo = valor;
  }

  setMyBlob(body: Blob) {
    this.myblob = body;
  }

  getMyBlob(): Blob {
    return this.myblob;
  }

  operacionesExtras() {
    // console.log('se ejecuto NxMPromo');
  }

  private itemData() {
    return this.getItemsData()[0];
  }

  private cantidadLlevar(): number {
    const item = this.itemData();
    return item ? item.cantidad1 : 0;
  }

  private cantidadPagar(): number {
    const item = this.itemData();
    return item ? item.cantidad2 : 0;
  }

  private precioItem(): number {
    const item = this.itemData();
    return item ? item.precioReal : 0;
  }

  /**
   * NxM reemplaza al articulo unico de la promo (equivalente a articulo1 en
   * las promos tipo P), tomandolo de los items resueltos por asignarPromociones().
   */
  articuloenPromo(): ArticulosEcommerce | null {
    return this.getArticulosItems()[0] || null;
  }

  cantidadenPromo(): number {
    return this.cantidadLlevar();
  }

  getDescontadoTotal(): number {
    return this.descontado;
  }

  getDescontado(): number {
    const grupos = this.getGruposCompletos();
    return grupos > 0 ? this.descontado / grupos : 0;
  }

  getGruposCompletos(): number {
    const articulo = this.articuloenPromo();
    const llevar = this.cantidadLlevar();
    if (!articulo || !llevar) {
      return 0;
    }
    return Math.floor(articulo.getCantidad() / llevar);
  }

  getPrecioCalculado(): number {
    const articulo = this.articuloenPromo();
    const llevar = this.cantidadLlevar();
    const pagar = this.cantidadPagar();
    const precio = this.precioItem();
    if (!articulo || !llevar) {
      return 0;
    }
    const cantidad = articulo.getCantidad() !== 0 ? articulo.getCantidad() : llevar;
    const grupos = Math.floor(cantidad / llevar);
    const resto = cantidad % llevar;
    return (grupos * pagar + resto) * precio;
  }

  preconPromo(precio: number, cantidad: number, modificacionActual: number) {
    const llevar = this.cantidadLlevar();
    const pagar = this.cantidadPagar();
    if (!llevar) {
      return 0;
    }
    const grupos = Math.floor(cantidad / llevar);
    const descuentoPorGrupo = (llevar - pagar) * this.precioItem();
    const olleg = grupos * descuentoPorGrupo;
    this.descontado += olleg;
    return -olleg;
  }

  getPrecioAmostrar() {
    return this.getPrecioCalculado();
  }

  getPrecio() {
    const articulo = this.articuloenPromo();
    const cantidad = articulo ? articulo.getCantidad() : 0;
    return cantidad > 0 ? this.getPrecioCalculado() / cantidad : this.precioItem();
  }

  getPrecioSinImp() {
    throw new Error('Method not implemented.');
  }

  agregarCantidad(numero: number) {
    const articulo = this.articuloenPromo();
    if (!articulo) {
      return;
    }
    articulo.agregarCantidad(numero * this.cantidadLlevar());
    articulo.operacionesExtras();
  }

  setCantidad(arg0: number) {
    this.counter = arg0;
  }

  hacerCalculos() {
    const articulo = this.articuloenPromo();
    if (!articulo || articulo.getCantidad() <= 0) {
      return 0;
    }
    return this.getPrecioCalculado() - articulo.getPrecio() * articulo.getCantidad();
  }

  aplicarPromocion(precio: number) {
    const llevar = this.cantidadLlevar();
    const pagar = this.cantidadPagar();
    if (!llevar) {
      return precio;
    }
    return precio * (pagar / llevar);
  }

  deOferta: OfertasEcommerce;
  isdeoferta: boolean;
  isdePromo: boolean;
  misPromo: PromocionesEccomerce[];

  private myblob: Blob;
}
